<template>
  <div class="prospectCreditCheck">
    <template v-if="!prospect.credit_check || this.prospect.credit_check === 'not_initiated'">
      <div class="d-flex">
        <Icon :name="IconName.InterfaceAlert" class="text-primary" />
        <h5 class="ml-2">Inviter til Kredittsjekk</h5>
      </div>

      <p class="text-gray2">
        Vi anbefaler alle utleiere å gjennomføre en kredittsjekk av leietaker før inngåelse av husleiekontrakt.
        <a
          href="https://husleie-no.zendesk.com/hc/no/articles/18053338222748-Hvordan-kan-jeg-gjennomf%C3%B8re-en-kredittsjekk-av-en-potensiell-leietaker"
          target="_blank"
          rel="noopener"
        >
          <strong><u>Les mer</u></strong>
        </a>
      </p>

      <hl-Button variant="primary" @click="toggleCreditCheckModal({ candidate: prospect, iMId: iMId })">
        Inviter til kredittsjekk
      </hl-Button>
    </template>

    <template v-else-if="prospect.credit_check === 'candidate_invited'">
      <div class="d-flex">
        <Icon :name="IconName.TimeHourglass" class="text-warning" />
        <h5 class="ml-2">Invitert til kredittsjekk</h5>
      </div>

      <p class="text-gray2">
        Invitasjon til kredittsjekk er blitt sendt. Vi vil informere deg når leietaker har svart på invitasjonen.
        <a
          href="https://husleie-no.zendesk.com/hc/no/articles/18053338222748-Hvordan-kan-jeg-gjennomf%C3%B8re-en-kredittsjekk-av-en-potensiell-leietaker"
          target="_blank"
          rel="noopener"
        >
          <strong><u>Les mer</u></strong>
        </a>
      </p>
    </template>

    <template v-else-if="prospect.credit_check === 'candidate_rejected'">
      <div class="d-flex">
        <Icon :name="IconName.InterfaceAlert" class="text-warning" />
        <h5 class="ml-2">Avstått kredittsjekk</h5>
      </div>

      <p class="text-gray2">
        Leietaker har valgt å ikke akseptere din invitasjon til kredittsjekk. Les mer om hva du kan gjøre her.
        <a
          href="https://husleie-no.zendesk.com/hc/no/articles/18053338222748-Hvordan-kan-jeg-gjennomf%C3%B8re-en-kredittsjekk-av-en-potensiell-leietaker"
          target="_blank"
          rel="noopener"
        >
          <strong><u>Les mer</u></strong>
        </a>
      </p>
    </template>

    <template v-else-if="prospect.credit_check === 'negative'">
      <div class="d-flex">
        <Icon :name="IconName.InterfaceAlert" class="text-danger" />
        <h5 class="ml-2">Negativ kredittsjekk</h5>
      </div>
      <p class="text-gray2">
        Denne leietakeren har ikke bestått kredittsjekk. Vi anbefaler at du ikke går videre med denne leietakeren.
        <a
          href="https://husleie-no.zendesk.com/hc/no/articles/18053338222748-Hvordan-kan-jeg-gjennomf%C3%B8re-en-kredittsjekk-av-en-potensiell-leietaker"
          target="_blank"
          rel="noopener"
        >
          <strong><u>Les mer</u></strong>
        </a>
      </p>
    </template>

    <template v-else-if="prospect.credit_check === 'positive'">
      <div class="d-flex">
        <Icon :name="IconName.InterfaceVerified" class="text-primary" />
        <h5 class="ml-2">Kredittsjekk bestått</h5>
      </div>

      <p class="text-gray2">
        Leietaker har bestått kredittsjekk. Basert på den positive kredittsjekken kan dette være en egnet kandidat.
        <a
          href="https://husleie-no.zendesk.com/hc/no/articles/18053338222748-Hvordan-kan-jeg-gjennomf%C3%B8re-en-kredittsjekk-av-en-potensiell-leietaker"
          target="_blank"
          rel="noopener"
        >
          <strong><u>Les mer</u></strong>
        </a>
      </p>
    </template>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import Icon, { IconName } from '@modules/design-system/components/Icon';

export default Vue.extend({
  name: 'ProspectCreditCheck',
  data() {
    return {
      IconName,
    };
  },
  props: {
    prospect: {
      type: Object,
      required: true,
    },
    iMId: {
      type: String,
      required: true,
    },
  },
  components: {
    Icon,
  },
  computed: {
    isCreditCheckStarted() {
      return Object.keys(this.prospect.credit_check).length;
    },
    isCreditCheckInvited() {
      return this.prospect.credit_check.status === 'invited';
    },
    isCreditCheckCeded() {
      return this.prospect.credit_check.status === 'rejected';
    },
    isCreditCheckNegative() {
      return (
        parseInt(this.prospect.credit_check.result?.remarks) || !this.prospect.credit_check.result?.tax_years.length
      );
    },
    isCreditCheckCompleted() {
      return this.prospect.credit_check.status === 'completed';
    },
  },
  methods: {
    ...mapActions(['toggleCreditCheckModal']),
  },
});
</script>
